import { logoutUser } from '../Api/Api';
import useUserDataStore from '../../store/userDataStore';
import { clearToken } from '../../util/tokenManager';
import { useNavigate } from 'react-router-dom';

export const useLogout = () => {
  const clearUserData = useUserDataStore((state) => state.clearUserData);
  const navigate = useNavigate();

  const logout = async () => {
    // Clear local authentication state immediately
    clearToken();
    clearUserData();

    // Navigate to login FIRST to prevent error flash
    navigate('/swapandtop/login', { replace: true });

    // Call backend logout in background (doesn't affect UI)
    // This includes timeout protection and proper error handling
    logoutUser().catch(() => {
      // Silently handle errors - user is already logged out on frontend
    });
  };

  return logout;
};
